<div class="page-content" *ngIf="currentUser.role.seeLogSistemControl">
  <div class="header">
    <div class="back-content">
      <mat-icon (click)="back()">arrow_back_ios</mat-icon>
    </div>
    <div class="title">
      <h3>Log control del sistema</h3>
    </div>
    <div class="isLoading">
      <div *ngIf="isLoading" style="text-align: center">Cargando...</div>
      <div class="loading" *ngIf="isLoading">
        <mat-spinner diameter="18"></mat-spinner>
      </div>
    </div>
    <div class="divCsv">
      <button (click)="exportToCsv()" mat-button class="btnCsv primary-btn">
        Exportar CSV
      </button>
    </div>
    <!-- <div class="search-content">
      <div class="searchbar">
        <input
          class="search_input"
          type="text"
          placeholder="Filtrar..."
          (keyup)="filter($event)"
        />
        <button class="search_icon">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div> -->
    <div class="divParentSearch">
      <div class="search-content">
        <div class="divFilter">
          <button
            (click)="searchTouch = !searchTouch"
            mat-button
            class="btnCsv primary-btn"
          >
            <mat-icon class="tune">tune</mat-icon>
            Filtros <span class="countFilters">{{ count }}</span>
          </button>
        </div>
        <div class="search-content">
          <div class="searchbar">
            <input
              class="search_input"
              type="text"
              placeholder="Filtrar..."
              (keyup)="filter($event)"
            />
            <button class="search_icon">
              <i class="fas fa-search"></i>
            </button>
          </div>

          <filter-log
            (count)="setCount($event)"
            [open]="searchTouch"
          ></filter-log>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="table-content mat-elevation-z8">
      <div class="table-scroll">
        <!-- Mat table -->
        <table mat-table [dataSource]="dataSourceAuditory" matTableFilter>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Rol</th>
            <td mat-cell *matCellDef="let element">
              {{ element.role }}
            </td>
          </ng-container>
          <ng-container matColumnDef="id_user">
            <th mat-header-cell *matHeaderCellDef>id usuario</th>
            <td mat-cell *matCellDef="let element">
              {{ element.id_user }}
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Acción</th>
            <td mat-cell *matCellDef="let element">
              {{ element.action }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ip">
            <th mat-header-cell *matHeaderCellDef>IP</th>
            <td mat-cell *matCellDef="let element">
              {{ element.ip }}
            </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let element">
              {{ element.date | date : "d/M/yy, h:mm:ss a" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="moreInfo">
            <th mat-header-cell *matHeaderCellDef>Mas Información</th>
            <td mat-cell *matCellDef="let element">
              {{ element.more_info }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsAuditory"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsAuditory"
          ></tr>
        </table>
      </div>
      <mat-paginator
        #auditoryPaginator
        [pageSizeOptions]="[10, 25, 100]"
        aria-label="Select page of roles"
      ></mat-paginator>
    </div>
  </div>
</div>
